import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';

@Component({
  selector: 'dl-notification-title',
  standalone: true,
  imports:[OneWebComponentsAngularModule,ReactiveFormsModule],
  templateUrl: './notification-title.component.html',
  styleUrl: './notification-title.component.scss'
})
export class NotificationTitleComponent {

  constructor(private _QnSbnDataService:QnSbnDataServiceService) { }
  
  public notificationTitleformctrl = new FormControl('Rajesh', [Validators.minLength(3), Validators.maxLength(256)]);
  // public localNotificationData: any;
  public localNotificationData: any = {}; 
  private lastTitle: string = '';
  private isUpdating = false;
  ngOnInit(): void {
    this._QnSbnDataService.mappingData$.subscribe(observer=>{
      if(this.isUpdating) return;
      if(!this._QnSbnDataService.isEmpty(observer['localNotificationId'])){
        this.localNotificationData = observer['localNotificationId'];
        this.lastTitle = observer['localNotificationId']['Title'] || '';
        this.notificationTitleformctrl.setValue(this.lastTitle, { emitEvent: false });
      }
    })
  }
  ngDoCheck() {
    const currentTitle = this.notificationTitleformctrl.value || '';
    if (currentTitle !== this.lastTitle) {
      this.lastTitle = currentTitle;
      this.addProduct(currentTitle);
    }
  }
  ngOnDestroy(): void {
    this.addProduct(this.notificationTitleformctrl.value);
  }

  public addProduct(title) {
    this.localNotificationData['Title'] = title;
    this.isUpdating = true;
    this._QnSbnDataService.getMappedQnsbnData(this.localNotificationData,"LocalNotificationId");
    this.isUpdating = false;
  }
}

